import { useEffect } from "react";
import { useAuth } from "../common/hooks/useAuth";

const SHOWME_SCRIPT_ID = "showme-widget-script";
const SHOWME_CDN = "https://cdn.solving.ai/showme/v1/client.js";

const ShowMeWidget = () => {
  const { userInfo, isAdmin } = useAuth();
  const showmeID = process.env.REACT_APP_SHOWME_ID;

  useEffect(() => {
    if (!isAdmin) return;

    if (!showmeID) {
      console.warn(
        "[ShowMeWidget] REACT_APP_SHOWME_ID is not set — widget will not load."
      );
      return;
    }

    const init = () => {
      window.initShowme?.({ showmeID, userID: userInfo?.id });
    };

    if (document.getElementById(SHOWME_SCRIPT_ID)) {
      init();
      return;
    }

    const script = document.createElement("script");
    script.id = SHOWME_SCRIPT_ID;
    script.src = SHOWME_CDN;
    script.async = true;
    script.onload = init;
    document.body.appendChild(script);
  }, [showmeID, userInfo?.id, isAdmin]);

  return null;
};

export default ShowMeWidget;
